(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('battery-test', {
            parent: 'entity',
            url: '/battery-test',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.batteryTest.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/battery-test/battery-tests.html',
                    controller: 'BatteryTestController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('batteryTest');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('battery-test-detail', {
            parent: 'entity',
            url: '/battery-test/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ipmApp.batteryTest.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/battery-test/battery-test-detail.html',
                    controller: 'BatteryTestDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('batteryTest');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BatteryTest', function($stateParams, BatteryTest) {
                    return BatteryTest.get({id : $stateParams.id});
                }]
            }
        })
        .state('battery-test.new', {
            parent: 'battery-test',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery-test/battery-test-dialog.html',
                    controller: 'BatteryTestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                orderNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('battery-test', null, { reload: true });
                }, function() {
                    $state.go('battery-test');
                });
            }]
        })
        .state('battery-test.edit', {
            parent: 'battery-test',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery-test/battery-test-dialog.html',
                    controller: 'BatteryTestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BatteryTest', function(BatteryTest) {
                            return BatteryTest.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('battery-test', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('battery-test.delete', {
            parent: 'battery-test',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/battery-test/battery-test-delete-dialog.html',
                    controller: 'BatteryTestDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BatteryTest', function(BatteryTest) {
                            return BatteryTest.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('battery-test', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
